import type { TQuestionRule } from 'types/rules.types';

// Frontend mirror of mergeRulesById/removeRulesByIds in the backend's templates.service.ts —
// needed to patch the Library slice's cached copy of a question's rules after a direct-to-question
// write, since the apply-rule-change response only carries the template, not the question, and
// nothing else ever refreshes that cache (see updateLibraryQuestionRules).

// Applies `incoming` onto `existing` by rule id: a matching id overwrites that rule in place (same
// position), an id not already present is appended.
export function mergeRulesById(existing: TQuestionRule[], incoming: TQuestionRule[]): TQuestionRule[] {
  const merged = [...existing];
  for (const rule of incoming) {
    const index = merged.findIndex((r) => r.id === rule.id);
    if (index === -1) {
      merged.push(rule);
    } else {
      merged[index] = rule;
    }
  }
  return merged;
}

// The removal counterpart to mergeRulesById — drops every rule whose id is in `ids`, leaving
// everything else (including order) untouched.
export function removeRulesByIds(rules: TQuestionRule[], ids: string[]): TQuestionRule[] {
  const idsToRemove = new Set(ids);
  return rules.filter((rule) => !idsToRemove.has(rule.id));
}
